<template>
  <v-stepper v-model="stepper" class="elevation-0">
    <v-stepper-header class="elevation-0">
      <v-stepper-step :complete="stepper > 1" step="1">Info</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="stepper > 2" step="2">Disable</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">Done</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <p class="fa-title">2FA enabled <v-img scr="/img/done_acvite.svg" /></p>
        <p class="fa-desc" style="margin-top: 24px;">
          2 factor authentication is enabled for your account.
        </p>
        <p class="fa-desc">
          If you want to disable 2 factor authentication, click the continue
          button below.
        </p>

        <v-btn
          color="primary"
          style="margin-top: 100px !important;"
          @click="stepper = 2"
          >Continue</v-btn
        >
      </v-stepper-content>

      <v-stepper-content step="2" style="padding-top: 6px;">
        <p class="fa-desc">
          To verify that you are really you please enter your password and,
          using the authenticator app, a valid 2fa code below.
        </p>

        <div>
          <v-text-field
            v-model="disableForm.password"
            :type="disableForm.passwordShow ? 'text' : 'password'"
            name="disableFormPassword"
            label="Password"
          >
            <template v-slot:append>
              <img
                width="24"
                height="24"
                :src="password_icon"
                @click="togglePassword"
              />
            </template>
          </v-text-field>
          <v-text-field
            v-model="disableForm.code"
            name="disableFormCode"
            label="2fa code"
            @keyup.enter="disable"
          ></v-text-field>
        </div>

        <v-btn
          color="primary"
          style="margin-top: 52px;"
          :disabled="loading"
          @click="disable"
          >Disable</v-btn
        >
        <v-btn
          flat
          class="btn-back btn-back-step-2"
          @click="stepper = 1"
          >Back</v-btn
        >
      </v-stepper-content>

      <v-stepper-content
        step="3"
        style="margin-top: 28px;"
      >
        <div>
          <div class="text-xs-center">
            <span class="disable-title">
              Disabled
              <v-img
                class="ml-2"
                src="/img/done_inactive.svg"
                width="24"
                style="display: inline-flex;"
              />
            </span>
          </div>
          <div class="text-xs-center mt-4 mb-4">
            <p class="disable-text mb-4">
              2 factor authentication is now disabled.
            </p>
          </div>
          <v-btn class="ml-0" style="margin-top: 84px;" :disabled="loading" @click="updateUserData"
          >Re-enable 2FA</v-btn>
        </div>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<style scoped>
.btn-back-step-2 {
  margin-top: 52px !important;
}
.btn-back {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #103a84 !important;
  background: #e6efff;
  border-radius: 30px;
  width: 147px;
  height: 44px;
  margin: 12px 6px 8px;
  box-shadow: none !important;
}
.theme--light >>> .v-stepper__label {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #8691a4;
}
.theme--light >>> .v-stepper__step__step.primary {
  background-color: #7ec171 !important;
  border-color: #7ec171 !important;
}
.theme--light >>> .v-stepper__step__step {
  background-color: #8691a4 !important;
  border-color: #8691a4 !important;
}
.theme--light p.fa-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  color: #103a84;
}
.theme--light p.fa-desc {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #103a84;
}
.theme--light .disable-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  text-align: center;
  color: #103a84;
}
.theme--light .disable-text {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  text-align: center;
  color: #103a84;
}
.theme--light .disable-text a {
  color: #639bfb;
}
/***********************/
.theme--dark .v-stepper {
  background: #212121;
}
.theme--dark >>> .v-stepper__step.v-stepper__step--complete .v-stepper__step__step.primary .v-icon{
  color: #000000;
}
.theme--dark >>> .v-stepper__step.v-stepper__step--active .v-stepper__label {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #e9e9e9;
  text-shadow: none;
}
.theme--dark >>> .v-stepper__label {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(235, 235, 245, 0.3);
}
.theme--dark >>> .v-stepper__step__step.primary {
  background-color: #7ec171 !important;
  border-color: #7ec171 !important;
  color: #000000;
}
.theme--dark >>> .v-stepper__step__step {
  background-color: rgba(235, 235, 245, 0.3) !important;
  border-color: rgba(235, 235, 245, 0.3) !important;
}
.theme--dark p.fa-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  color: #e9e9e9;
}
.theme--dark p.fa-desc {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #e9e9e9;
}
.theme--dark .disable-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  text-align: center;
  color: #e9e9e9;
}
.theme--dark .disable-text {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  text-align: center;
  color: #e9e9e9;
}
.theme--dark .disable-text a {
  color: #0051dd;
}
.theme--dark .btn-back {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #e9e9e9 !important;
  background: #454547;
  border-radius: 30px;
  width: 147px;
  height: 44px;
  margin: 12px 6px 8px;
  box-shadow: none !important;
}

@media only screen and (max-width: 959px) {
  .theme--light.v-stepper .v-stepper__step--active >>> .v-stepper__label {
    display: flex !important;
    font-family: "Lato", serif !important;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #103a84;
    text-shadow: none;
    margin-left: 12px;
  }
}
@media (max-width: 450px) {
  .btn-back-step-2 {
    margin-top: 8px !important;
  }
}
</style>

<script>
import axios from "axios";
import swal from "sweetalert2";
import {mapGetters} from "vuex";

export default {
  name: "TwoFactorDisable",
  props: ["skip"],
  data: function() {
    return {
      loading: false,
      stepper: 0,
      disableForm: {
        password: null,
        passwordShow: false,
        code: null
      },
      password_icon: "/img/eye-icon.svg"
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      themeDark: "settings/darkmode"
    })
  },
  created: function() {
    if (this.skip) {
      this.stepper = 2;
    }
  },
  methods: {
    reload: function() {
      window.location.reload();
    },
    updateUserData: async function() {
      this.user["google_2fa_enabled"] = false;
      this.$emit("updateDisableSkipSteps", {
        skipDisableStepOne: true
      });
      await this.$store.dispatch("auth/updateUser", this.user);
    },
    disable: async function() {
      this.loading = true;

      try {
        await axios.post("api/v1/two-factor/disable", {
          "2fa_code": this.disableForm.code,
          password: this.disableForm.password
        });

        this.loading = false;
        this.stepper = 3;

        return true;
      } catch (error) {
        swal({
          title: "Something went wrong",
          text:
            "Please enter your password and a valid 2-factor code using the authenticator app.",
          showConfirmButton: false,
          showCloseButton: true,
          customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
          imageUrl: "/img/popup_img_error.png",
          imageHeight: 80,
          imageWidth: 80
        });

        this.loading = false;
        return false;
      }
    },
    togglePassword() {
      this.disableForm.passwordShow = !this.disableForm.passwordShow;
      this.password_icon =
        this.disableForm.passwordShow === "password"
          ? "/img/eye-icon.svg"
          : "/img/eye-open-icon.svg";
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/settings/TwoFactorDisable.vue